import AuthorizedComponent from './AuthorizedComponent';

export default AuthorizedComponent;
